import { Component } from '@angular/core';

import { DashboardStore } from '../dashboardv2.store';

@Component({
  selector: 'app-dashboard-system-revenue',
  standalone: false,
  templateUrl: './dashboard-system-revenue.component.html',
  styleUrls: [
    '../dashboardv2.component.scss',
    './dashboard-system-revenue.component.scss',
  ],
})
export class DashboardSystemRevenueComponent {

  viewModel$ = this.dashboardStore.systemRevenueViewModel$;

  triggerReload = this.dashboardStore.triggerReload;

  constructor(
    private readonly dashboardStore: DashboardStore,
  ) {}

}
